import { gql } from '@apollo/client'
import { CompanyNodeFragment } from '@src/graphql/Company/Fragments'
import { FileUploadNodeFragment } from '@src/graphql/FileUpload/Fragments'
import { DriverInventoryNodeFragment } from '@src/graphql/Inventory/Fragments'
import { DriverPileNodeFragment } from '@src/graphql/Pile/Fragments'
import { VehicleNodeFragment } from '@src/graphql/Vehicle/Fragments'

// DESKTOP

export const OrderAllFieldsNodeFragment = gql`
  fragment orderAllFieldsNode on OrderNode {
    id
    createdBy {
      firstName
      lastName
    }
    createdAt
    lastmodifiedBy {
      firstName
      lastName
    }
    lastmodifiedAt
    number
    status
    planDate
    repeat
    repeatEndDate
    note
    noteDriver
    deliveryType
    deliveryNumber
    weightFormNumber
    type
    collectedFromOtherSystem
    canBeAborted
    finishedAt
    isPlausible
    vehicle {
      id
      registrationNumber
      milage
    }
  }
`

export const OrderStatusNodeFragment = gql`
  fragment orderStatusNode on OrderStatusNode {
    id
    status
  }
`

export const OrderTypeNodeFragment = gql`
  fragment orderTypeNode on OrderNode {
    type
  }
`

export const TimeNodeFragment = gql`
  fragment timeNode on TimeNode {
    id
    begin
    end
    kmBegin
    kmEnd
  }
`

export const OrderNodeFragment = gql`
  fragment orderNode on OrderNode {
    id
    number
    status
    repeat
    planDate
    finishedAt
    repeatEndDate
    note
    noteDriver
    collectedFromOtherSystem
    isPlausible
  }
`

export const StatusChangeNodeFragment = gql`
  fragment statusChange on StatusChangeNode {
    id
    createdAt
    createdBy {
      firstName
      lastName
    }
    oldStatus
    newStatus
    dispatchedAt
    milage
  }
`

// MOBILE

export const DriverOrderNodeFragment = gql`
  fragment driverOrderNode on OrderNode {
    id
    number
    status
    repeat
    repeatEndDate
    planDate
    note
    noteDriver
    driver {
      id
    }
    customer {
      ...companyNode
    }
    supplier {
      ...companyNode
    }
    piles {
      edges {
        node {
          ...driverPileNode
        }
      }
    }
    inventories {
      edges {
        node {
          ...driverInventoryNode
        }
      }
    }
    route {
      edges {
        node {
          index
          latitude
          longitude
        }
      }
    }
    transportMedia {
      ...fileUploadNode
    }
    deliveryNoteCustomer {
      ...fileUploadNode
    }
    deliveryNoteSupplier {
      ...fileUploadNode
    }
    vehicle {
      ...vehicleNode
    }
  }
  ${CompanyNodeFragment}
  ${DriverPileNodeFragment}
  ${DriverInventoryNodeFragment}
  ${FileUploadNodeFragment}
  ${VehicleNodeFragment}
`
